type Props = {
  text: string | JSX.Element;
  isSelected: boolean;
  callback: () => void;
  width?: string;
  height?: string;
  disabled?: boolean;
  className?: string;
  ["data-cy"]?: string;
};

const PaginationButton = ({
  text,
  isSelected,
  callback,
  width,
  height,
  disabled,
  className,
  ...props
}: Props) => {
  return (
    <button
      className={`flex ${width || "w-9"} ${
        height || "h-9"
      } cursor-pointer items-center justify-center rounded-md text-center shadow-md
        ${isSelected ? "bg-secondary text-white" : "bg-surface text-primary"}
        disabled:bg-[#D9DDDE]
        ${disabled && "text-[#7D8B94]"}
        ${className}`}
      onClick={callback}
      disabled={disabled}
      data-cy={props["data-cy"]}
    >
      {text}
    </button>
  );
};

export default PaginationButton;
